//react
import React from "react"
// material-ui
import FlatButton from "material-ui/FlatButton"


export default ({
    onAdd,
    onEdit,
    onRemove,
    disabled = false,
    labels = {
        add: "Add",
        edit: "Edit",
        remove: "Remove"
    },
    className = ""
}) =>
    <div className={ className }>
        <FlatButton
            key="add"
            label={ labels.add }
            primary={ true }
            onTouchTap={ onAdd }
        />
        <FlatButton
            key="edit"
            label={ labels.edit }
            onTouchTap={ onEdit }
            disabled={ disabled }
        />
        <FlatButton
            key="remove"
            label={ labels.remove }
            secondary={ true }
            onTouchTap={ onRemove }
            disabled={ disabled }
        />
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/common/buttons/AddEditRemove/add-edit-remove-btns.js
 **/